import * as React from 'react'
import { SearchForm } from '#app/components/forms/search-form/search-form.tsx'
import { type Locale } from '#app/models/locale'
import { type App } from '#app/routes/_layout/component.route.tsx'

/* -------------------------------------------------------------------------------------------------
 * Search params
 * -----------------------------------------------------------------------------------------------*/

enum SEARCH_PARAMS {
	subaction = 'subaction',
	q = 'q',
}

/* -------------------------------------------------------------------------------------------------
 * Search
 * -----------------------------------------------------------------------------------------------*/

type SearchProps = {
	cartCount: number
	locale: Locale
	setApp: React.Dispatch<React.SetStateAction<App>>
}

const Search: React.FC<SearchProps> = ({ cartCount, locale, setApp }) => {
	return <SearchForm cartCount={cartCount} locale={locale} setApp={setApp} />
}
Search.displayName = 'Search'

/* -----------------------------------------------------------------------------------------------*/

export { Search, SEARCH_PARAMS as SEARCH_SEARCH_PARAMS }
